/**
 * Catalog discount id for the one-time yearly Max complimentary offer
 * (ml-scribe `AvailableDiscounts.yearly_max_complimentary_15`). Kept as a
 * string constant until OpenAPI schema regen lands the enum member.
 */
export const YEARLY_MAX_COMPLIMENTARY_15 = 'yearly_max_complimentary_15' as const;

export type YearlyMaxComplimentaryDiscount = typeof YEARLY_MAX_COMPLIMENTARY_15;
